import { useMutation } from '@tanstack/react-query';
import { awaitJSON, MiscLambdaFetch } from '../../../utils/fetch-utils';
import { useSetError } from '../../../redux/modals';

interface TaskFix {
  taskName: string;
  enabled: boolean;
}

interface CommissionFix {
  company: string;
  month: string;
  commission: number;
}

interface ApplySystemHealthFixParams {
  key: string;
  tasks?: TaskFix[];
  commission?: CommissionFix[];
}

interface ApplySystemHealthFixResponse {
  applied: number;
}

// The applied fix won't disappear from the check's rows until the next scheduled
// system-health run picks it up -- callers track "applied" locally for immediate feedback.
export const useApplySystemHealthFix = () => {
  const setError = useSetError();
  return useMutation({
    mutationFn: async ({ key, tasks, commission }: ApplySystemHealthFixParams) => {
      const response = await MiscLambdaFetch('/system_health/apply', {
        method: 'POST',
        body: { key, tasks, commission }
      });
      return awaitJSON<ApplySystemHealthFixResponse>(response);
    },
    onError: error =>
      setError({ message: `Couldn't apply the fix: ${error.message}`, reportError: error })
  });
};
